(function (angular) {
    'use strict';

    angular.module('app')
        .controller('manageCardsController', manageCardsController);

    manageCardsController.$inject = [
        '$uibModalInstance',
        '$scope',
        '$rootScope',
        'CardsApi',
        'handleError',
        'Stripe',
    ];

    function manageCardsController(
        $uibModalInstance,
        $scope,
        $rootScope,
        CardsApi,
        handleError,
        Stripe
    ) {
        var vm = this;

        // properties
        vm.thisUser = $rootScope.thisUser;
        vm.isLoading = true;
        vm.errorMsg = null;
        vm.useNewCard = false;
        vm.newCard = {
            number: '',
            cvc: '',
            exp_month: 1,
            exp_year: new Date()
                .getFullYear()
                .toString().substr(2, 4)
        };
        vm.card = {
            card_brand: '',
            card_last_four: '',
            stripe_id: ''
        };

        // methods.
        vm.selectCard = selectCard;
        vm.saveCard = saveCard;
        vm.close = $uibModalInstance.close;

        CardsApi.get(function (resp) {
            vm.card = resp.data;
            if (resp.data && resp.data.card_brand) {
                vm.card.card_brand_formatted = resp.data.card_brand.toLowerCase().replace(/ /g, '_');
            }

            if (vm.card.stripe_id) {
                vm.useNewCard = false;
            }

            vm.isLoading = false;
        });

        /**
         * Select an existing card.
         * @return {void}
         */
        function selectCard(card) {
            $uibModalInstance.close(card);
        }

        /**
         * Save a new card.
         *
         * @return {void}
         */
        function saveCard() {
            vm.isLoading = true;
            vm.errorMsg = null;

            Stripe.card.createToken(vm.newCard, function(status, resp) {
                vm.isLoading = false;

                switch (status) {
                case 200:
                    var card = {
                        card_last_four: resp.card.last4,
                        card_brand: resp.card.brand,
                        stripe_id: resp.id
                    };
                    selectCard(card);
                    break;
                case 400:
                case 402:
                case 422:
                    $scope.$apply(function () {
                        vm.errorMsg = resp.error.message;
                    });
                    break;
                default:
                    $scope.$apply(function () {
                        vm.errorMsg = 'We had some difficulty connecting to Stripe. Please try again.';
                    });
                    break;
                }
            });
        }

        $scope.$on('modal.closing', function (event, reason,closed) {
            if (!closed) {
                return event.preventDefault();
            }
        });
    }

}(angular));
